var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0207 0C11.1849 0 0 11.2673 0 25.2066C0 36.349 7.16655 45.7808 17.1084 49.119C18.3514 49.3699 18.8067 48.5766 18.8067 47.9093C18.8067 47.3249 18.7658 45.3219 18.7658 43.2349C11.8056 44.7375 10.3562 40.2301 10.3562 40.2301C9.23769 37.3088 7.58037 36.5579 7.58037 36.5579C5.30231 35.0138 7.7463 35.0138 7.7463 35.0138C10.2733 35.1808 11.5992 37.6012 11.5992 37.6012C13.8358 41.4403 17.4398 40.3555 18.8897 39.6877C19.0966 38.0601 19.7599 36.9333 20.4641 36.3075C14.9128 35.7231 9.07227 33.5531 9.07227 23.8709C9.07227 21.1165 10.0658 18.8631 11.6402 17.1105C11.3918 16.4846 10.5217 13.8967 11.8891 10.4331C11.8891 10.4331 14.0017 9.76521 18.7653 13.0204C20.8047 12.4687 22.9079 12.188 25.0207 12.1856C27.1333 12.1856 29.2869 12.4781 31.2756 13.0204C36.0396 9.76521 38.1523 10.4331 38.1523 10.4331C39.5197 13.8967 38.6491 16.4846 38.4007 17.1105C40.0165 18.8631 40.9691 21.1165 40.9691 23.8709C40.9691 33.5531 35.1285 35.6811 29.5358 36.3075C30.4475 37.1003 31.2341 38.6024 31.2341 40.9814C31.2341 44.3616 31.1931 47.0745 31.1931 47.9088C31.1931 48.5766 31.649 49.3699 32.8914 49.1195C42.8333 45.7803 49.9999 36.349 49.9999 25.2066C50.0409 11.2673 38.815 0 25.0207 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.c89f4e0450f3c2cbb36a156e34444ba5.svg";
export { ForwardRef as ReactComponent };